import { render, staticRenderFns } from "./createTodo.vue?vue&type=template&id=49c19f9a&"
import script from "./createTodo.vue?vue&type=script&lang=ts&"
export * from "./createTodo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports